$(document).on('turbolinks:load', function() {
  var coins_total = parseInt($('.coin-counter span').text()), coins_available;
  set_available_coins();
  $('.student-rewards').on('click', '.quantity a', function(e) {
    e.preventDefault();
    if($(this).closest('.rewards').hasClass('disabled')) return;
    let $input = $(this).closest('.quantity').find('input'),
      val = $input.val();
    $(this).hasClass('plus') ? val++ : val--;
    if(val < 0) {
      val = 0;
    }
    $input.val(val).trigger('change');
  });

  $('.student-rewards').on('change', '.quantity input', function() {
    if($(this).closest('.rewards').hasClass('disabled')) return;
    set_available_coins();
    $(this).closest('form').find('input[type="submit"]').addClass('active').prop('disabled', false);
  });

  function set_available_coins () {
    var coins_spent = 0;
    $('.quantity input').each(function () {
      coins_spent += parseInt($(this).val());
    });
    coins_available = coins_total - coins_spent;
    if(coins_available <= 0) {
      coins_available = 0;
      $('.quantity a.plus').addClass('disabled');
    } else {
      $('.quantity a.plus').removeClass('disabled');
    }
    $('.coins-available span').text(coins_available);
  }

});